// @flow
import type { Action } from '../types';
import * as constants from '../constants/appConstants';
import { TYPE as TARGET_TYPE} from '../constants/targetConstants';

const MIN_THROTTLING_INTERVAL = 100;

export type State = $ReadOnly<{
    activeSection: null | typeof constants.SECTION,
    target: null | $ReadOnly<{
        id: string,
        type: $Values<typeof TARGET_TYPE>
    }>,
    tis: {
        enabled: boolean,
        throttling: boolean,
        interval: number
    }
}>;

const initialState = {
    activeSection: null,
    target: null,
    tis: {
        enabled: true,
        throttling: true,
        interval: MIN_THROTTLING_INTERVAL
    }
};

export default function app(state: State = initialState, action: Action): State {
    switch(action.type) {
        case constants.SET_SECTION: {
            return {
                ...state,
                activeSection: action.data
            };
        }

        case constants.SET_TARGET: {
            return {
                ...state,
                target: action.data
            };
        }

        case constants.SET_TIS_ENABLED: {
            return {
                ...state,
                tis: {
                    ...state.tis,
                    enabled: action.data
                }
            };
        }

        case constants.SET_THROTTLING_INTERVAL: {
            return {
                ...state,
                tis: {
                    ...state.tis,
                    interval: Math.max(action.data, MIN_THROTTLING_INTERVAL)
                }
            };
        }

        default:
            return state;
    }
}